"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLSSignature = exports.BLSPublicKey = exports.DynamicId = exports.SupernetId = exports.NodeId = exports.Signature = exports.BlockchainId = exports.TransactionId = exports.AssetId = exports.Address = void 0;
const utils_1 = require("../utils");
const encoding = __importStar(require("../utils/encoding"));
const constants_1 = require("./constants");
function validateData(data) {
    if (data === undefined || data === null) {
        throw new utils_1.JuneoTypeError(`invalid byte data type: ${data}`);
    }
}
class Address extends utils_1.BytesData {
    constructor(address) {
        validateData(address);
        const buffer = typeof address === 'string' ? Address.decodeAddress(address) : address;
        if (buffer.length !== constants_1.AddressSize) {
            throw new utils_1.JuneoTypeError(`address is not ${constants_1.AddressSize} bytes long`);
        }
        super(buffer);
    }
    matches(address) {
        validateData(address);
        const buffer = typeof address === 'string' ? Address.decodeAddress(address) : address.getBuffer();
        if (buffer.length !== constants_1.AddressSize) {
            throw new utils_1.JuneoTypeError(`address is not ${constants_1.AddressSize} bytes long`);
        }
        return utils_1.JuneoBuffer.comparator(buffer, this.getBuffer()) === 0;
    }
    matchesList(addresses) {
        for (const address of addresses) {
            if (this.matches(address)) {
                return true;
            }
        }
        return false;
    }
    encode(hrp) {
        return encoding.encodeBech32(hrp, this.getBuffer());
    }
    encodeHex() {
        return `0x${this.serialize().toHex()}`;
    }
    static toAddresses(values) {
        if (values.length < 1) {
            throw new utils_1.JuneoTypeError('provided values length should be greater than 0');
        }
        const addresses = [];
        for (const value of values) {
            addresses.push(new Address(value));
        }
        return addresses;
    }
    static uniqueAddresses(addresses) {
        const unique = [];
        for (const address of addresses) {
            if (!address.matchesList(unique)) {
                unique.push(address);
            }
        }
        return unique;
    }
    static decodeAddress(address) {
        if (encoding.isHex(address)) {
            return encoding.decodeHex(address);
        }
        else {
            return encoding.decodeBech32(address);
        }
    }
}
exports.Address = Address;
class AssetId extends utils_1.BytesData {
    value;
    constructor(value) {
        validateData(value);
        const buffer = encoding.decodeCB58(value);
        if (buffer.length !== constants_1.AssetIdSize) {
            throw new utils_1.JuneoTypeError(`asset id is not ${constants_1.AssetIdSize} bytes long`);
        }
        super(buffer);
        this.value = value;
    }
    static validate(value) {
        validateData(value);
        if (!encoding.isBase58(value)) {
            return false;
        }
        const buffer = encoding.decodeCB58(value);
        return buffer.length === constants_1.AssetIdSize;
    }
}
exports.AssetId = AssetId;
class TransactionId extends utils_1.BytesData {
    value;
    constructor(value) {
        validateData(value);
        const buffer = encoding.decodeCB58(value);
        if (buffer.length !== constants_1.TransactionIdSize) {
            throw new utils_1.JuneoTypeError(`transaction id is not ${constants_1.TransactionIdSize} bytes long`);
        }
        super(buffer);
        this.value = value;
    }
}
exports.TransactionId = TransactionId;
class BlockchainId extends utils_1.BytesData {
    value;
    constructor(value) {
        validateData(value);
        const buffer = encoding.decodeCB58(value);
        if (buffer.length !== constants_1.BlockchainIdSize) {
            throw new utils_1.JuneoTypeError(`blockchain id is not ${constants_1.BlockchainIdSize} bytes long`);
        }
        super(buffer);
        this.value = value;
    }
}
exports.BlockchainId = BlockchainId;
class Signature extends utils_1.BytesData {
    r;
    s;
    v;
    constructor(signature) {
        validateData(signature);
        if (signature.length !== constants_1.SignatureSize) {
            throw new utils_1.JuneoTypeError(`signature is not ${constants_1.SignatureSize} bytes long`);
        }
        super(signature);
        const reader = signature.createReader();
        this.r = reader.read(32);
        this.s = reader.read(32);
        this.v = reader.readUInt8();
    }
    recoverAddress(message) {
        return (0, utils_1.recoverAddress)(this, message);
    }
}
exports.Signature = Signature;
class NodeId extends utils_1.BytesData {
    value;
    constructor(value) {
        validateData(value);
        const split = value.split('-');
        const parsedNodeId = split.length > 1 ? split[1] : split[0];
        const buffer = encoding.decodeCB58(parsedNodeId);
        if (buffer.length !== constants_1.NodeIdSize) {
            throw new utils_1.JuneoTypeError(`node id is not ${constants_1.NodeIdSize} bytes long`);
        }
        super(buffer);
        this.value = `NodeID-${parsedNodeId}`;
    }
}
exports.NodeId = NodeId;
class SupernetId extends utils_1.BytesData {
    value;
    constructor(value) {
        validateData(value);
        const buffer = encoding.decodeCB58(value);
        if (buffer.length !== constants_1.SupernetIdSize) {
            throw new utils_1.JuneoTypeError(`supernet id is not ${constants_1.SupernetIdSize} bytes long`);
        }
        super(buffer);
        this.value = value;
    }
}
exports.SupernetId = SupernetId;
class DynamicId extends utils_1.BytesData {
    value;
    constructor(value) {
        validateData(value);
        const buffer = utils_1.JuneoBuffer.alloc(constants_1.DynamicIdSize);
        if (value.length > buffer.length) {
            throw new utils_1.JuneoTypeError(`${value} is longer than ${constants_1.DynamicIdSize} bytes`);
        }
        buffer.writeString(value);
        super(buffer);
        this.value = value;
    }
}
exports.DynamicId = DynamicId;
class BLSPublicKey extends utils_1.BytesData {
    value;
    constructor(value) {
        validateData(value);
        const buffer = encoding.decodeHex(value);
        if (buffer.length !== constants_1.BLSPublicKeySize) {
            throw new utils_1.JuneoTypeError(`bls public key is not ${constants_1.BLSPublicKeySize} bytes long`);
        }
        super(buffer);
        this.value = value;
    }
}
exports.BLSPublicKey = BLSPublicKey;
class BLSSignature extends utils_1.BytesData {
    value;
    constructor(value) {
        validateData(value);
        const buffer = encoding.decodeHex(value);
        if (buffer.length !== constants_1.BLSSignatureSize) {
            throw new utils_1.JuneoTypeError(`bls signature is not ${constants_1.BLSSignatureSize} bytes long`);
        }
        super(buffer);
        this.value = value;
    }
}
exports.BLSSignature = BLSSignature;
